import { useSelector } from "react-redux";
import { CurrentUserState } from "../redux/current-user-slice";
import { AppState } from "../redux/store";
import { NotificationState } from "../redux/notification-slice";
import { useEffect, useState } from "react";

/**
 * Retrieves the notification count for read or unread buckets from the store.
 * @param read - Flag indicating which count to extract.
 * @returns Numeric count for the requested bucket.
 */
export function useNotificationCnt( read: boolean) {

    const _notification = useSelector<AppState>(state => state.notifications) as NotificationState;
    const [_notCount, setNotCount] = useState<number>(0);

    useEffect(() => {
        let count = _notification.counts.find(x => x.read === read);
        let value = 0;
        if (count) {
            value = count.count;
        }
        setNotCount(value);
    }, [_notification.counts])

    
    return _notCount;
}

